import { memo } from 'react';

import ExportIcon from '@/assets/export-icon.svg?react';
import { Logo, LogoProps } from '@/components/core';
import {
  AirtableLogo,
  APILogo,
  ExcelLogo,
  GoogleDriveLogo,
  GoogleSheetsLogo,
  MakeLogo,
  ManualLogo,
  MicrosoftOneDriveLogo,
  N8NLogo,
  PowerAutomateLogo,
  WebhookLogo,
  ZapierLogo,
} from '@/components/logos';
import {
  EXPORT_TO_AIRTABLE_FUNCTION_ID,
  EXPORT_TO_API_FUNCTION_ID,
  EXPORT_TO_GOOGLE_DRIVE_FUNCTION_ID,
  EXPORT_TO_GOOGLE_SHEETS_FUNCTION_ID,
  EXPORT_TO_MAKE_FUNCTION_ID,
  EXPORT_TO_MANUAL_FUNCTION_ID,
  EXPORT_TO_MICROSOFT_EXCEL_FUNCTION_ID,
  EXPORT_TO_MICROSOFT_ONE_DRIVE_FUNCTION_ID,
  EXPORT_TO_N8N_FUNCTION_ID,
  EXPORT_TO_POWER_AUTOMATE_FUNCTION_ID,
  EXPORT_TO_WEBHOOK_FUNCTION_ID,
  EXPORT_TO_ZAPIER_FUNCTION_ID,
} from '@/constants';

export type ExportLogoProps = LogoProps & {
  functionId?: string;
};

const IExportLogo = ({ functionId, ...rest }: ExportLogoProps) => {
  switch (functionId) {
    case EXPORT_TO_MANUAL_FUNCTION_ID:
      return <ManualLogo type="export" {...rest} />;
    case EXPORT_TO_WEBHOOK_FUNCTION_ID:
      return <WebhookLogo variant="plain" {...rest} />;
    case EXPORT_TO_MICROSOFT_EXCEL_FUNCTION_ID:
      return <ExcelLogo {...rest} />;
    case EXPORT_TO_ZAPIER_FUNCTION_ID:
      return <ZapierLogo {...rest} />;
    case EXPORT_TO_POWER_AUTOMATE_FUNCTION_ID:
      return <PowerAutomateLogo {...rest} />;
    case EXPORT_TO_MAKE_FUNCTION_ID:
      return <MakeLogo {...rest} />;
    case EXPORT_TO_N8N_FUNCTION_ID:
      return <N8NLogo {...rest} />;
    case EXPORT_TO_AIRTABLE_FUNCTION_ID:
      return <AirtableLogo {...rest} />;
    case EXPORT_TO_API_FUNCTION_ID:
      return <APILogo {...rest} />;
    case EXPORT_TO_MICROSOFT_ONE_DRIVE_FUNCTION_ID:
      return <MicrosoftOneDriveLogo {...rest} />;
    case EXPORT_TO_GOOGLE_DRIVE_FUNCTION_ID:
      return <GoogleDriveLogo {...rest} />;
    case EXPORT_TO_GOOGLE_SHEETS_FUNCTION_ID:
      return <GoogleSheetsLogo {...rest} />;
  }

  return (
    <Logo className="p-sm !border-none bg-teal-50 text-white" {...rest}>
      <ExportIcon className="text-teal-500" />
    </Logo>
  );
};

export const ExportLogo = memo(IExportLogo) as typeof IExportLogo;
